import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";
import { APIResource } from "./Resource";

export const DefaultSetID = "default";

export class TemplateSet extends APIResource {
  id: string;
  name: string;
  template_names: string[];
  disabled: boolean;

  baseURL = `${BACKEND_BASE_URL}/api/v1/template-sets`;
  upsertFields = ["id", "name", "template_names", "disabled"];

  constructor({
    id,
    name,
    template_names,
    disabled,
  }: {
    id: string;
    name: string;
    template_names: string[];
    disabled: boolean;
  }) {
    super();
    this.id = id;
    this.name = name;
    this.template_names = template_names;
    this.disabled = disabled;
  }

  id__validation(value: string) {
    if (!value) return "Should not be empty";
    if (!value.match(/^[a-zA-Z0-9]+$/)) return "Should not contain any special characters or whitespace";
  }

  name__validation(value: string) {
    if (!value) return "Should not be empty";
  }

  template_names__validation(values: string[]) {
    if (values?.length === 0) return "Should not be empty";
  }
}

export type TemplateSetAggregate = {
  id: string;
  name: string;
  templates: TemplateMapping[];
  disabled: boolean;
};

export type TemplateMapping = {
  id: string;
  name: string;
  prefix: string;
  color_space: string;
  segment_length: number;
};

export class TemplateSets {
  private static baseURL = `${BACKEND_BASE_URL}/api/v1/template-sets`;

  static async list(): Promise<TemplateSetAggregate[]> {
    const url = new URL(this.baseURL);
    const response = await request(url, { method: "GET" }, true);
    const json = await response?.json();
    return json?.sort(sortDefaultSetToTop) || [];
  }

  static async retrieve(id: string): Promise<TemplateSetAggregate> {
    const url = new URL(`${this.baseURL}/${id}`);
    const response = await request(url, { method: "GET" }, true);
    return await response.json();
  }
}

const sortDefaultSetToTop = (o1: TemplateSetAggregate, o2: TemplateSetAggregate): number => {
  // Keeps default set at the top
  if (o1.id === DefaultSetID) return -1;
  if (o2.id === DefaultSetID) return 1;
  return o1.name.localeCompare(o2.name);
};
